(function () {
  'use strict';

  var VERSION = '2026-09-02.2';
  if (window.__saunamoMetaContactTracking === VERSION) return;
  window.__saunamoMetaContactTracking = VERSION;

  var host = String(window.location.hostname || '').toLowerCase().replace(/^www\./, '');
  var trustedHosts = [
    'saunamo.pt',
    'saunamo.shop',
    'saunamo.es',
    'saunamo.fr',
    'saunamo.it',
    'saunamo.co.uk',
    'saunamo.us'
  ];
  if (trustedHosts.indexOf(host) === -1) return;
  document.documentElement.setAttribute('data-saunamo-meta-contact-tracking', VERSION);

  var endpoint = 'https://os.saunamo.pt/api/meta-contact-event';
  var lastClickKey = '';
  var lastClickAt = 0;

  function cookieValue(name) {
    var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + escaped + '=([^;]*)'));
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (_error) {
      return match[1];
    }
  }

  function consentFlag(value) {
    if (value === true || value === 1 || value === '1' || value === 'true' || value === 'granted') return true;
    if (value === false || value === 0 || value === '0' || value === 'false' || value === 'denied') return false;
    return null;
  }

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === 'function') {
        var shopifyDecision = consentFlag(privacy.marketingAllowed());
        if (shopifyDecision !== null) return shopifyDecision;
      }
    } catch (_error) {}

    try {
      var trackingConsent = cookieValue('_tracking_consent');
      if (trackingConsent) {
        var parsed = JSON.parse(trackingConsent);
        var cmp = parsed && parsed.con && parsed.con.CMP;
        var cmpDecision = consentFlag(cmp && cmp.m);
        if (cmpDecision !== null) return cmpDecision;
      }
    } catch (_error) {}

    var saunamoDecision = consentFlag(cookieValue('saunamo_consent'));
    return saunamoDecision === true;
  }

  function contactMethod(element) {
    if (!element) return '';
    if (element.hasAttribute && element.hasAttribute('data-whatsapp')) return 'whatsapp';

    var href = String(element.getAttribute && element.getAttribute('href') || '').trim();
    var lowerHref = href.toLowerCase();
    if (lowerHref.indexOf('tel:') === 0) return 'phone';
    if (lowerHref.indexOf('sms:') === 0) return 'sms';
    if (lowerHref.indexOf('mailto:') === 0) return 'email';
    if (lowerHref.indexOf('whatsapp:') === 0) return 'whatsapp';

    try {
      var url = new URL(href, window.location.href);
      var linkHost = url.hostname.toLowerCase().replace(/^www\./, '');
      if (
        linkHost === 'wa.me' ||
        linkHost === 'api.whatsapp.com' ||
        linkHost === 'web.whatsapp.com' ||
        linkHost === 'whatsapp.com' ||
        /(^|\.)whatsapp\.com$/.test(linkHost)
      ) return 'whatsapp';
    } catch (_error) {}
    return '';
  }

  function eventId() {
    var suffix = '';
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') suffix = window.crypto.randomUUID();
    } catch (_error) {}
    if (!suffix) suffix = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
    return 'contact:' + suffix.replace(/[^a-zA-Z0-9_-]/g, '');
  }

  function attribution() {
    var result = { ads_data_consent: 'granted' };
    var fbp = cookieValue('_fbp').slice(0, 500);
    var fbc = cookieValue('_fbc').slice(0, 500);
    if (!fbc) {
      try {
        var fbclid = new URL(window.location.href).searchParams.get('fbclid');
        if (fbclid) fbc = ('fb.1.' + Date.now() + '.' + fbclid).slice(0, 500);
      } catch (_error) {}
    }
    if (fbp) result.fbp = fbp;
    if (fbc) result.fbc = fbc;
    return result;
  }

  function deliver(payload) {
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var queued = navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        if (queued) return;
      }
    } catch (_error) {}

    try {
      window.fetch(endpoint, {
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        credentials: 'omit',
        keepalive: true,
        mode: 'cors'
      }).catch(function () {});
    } catch (_error) {}
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    var element = target && target.closest
      ? target.closest('a[href], [data-whatsapp], .whatsapp-button, .whatsapp-float')
      : null;
    var method = contactMethod(element);
    if (!method || !marketingAllowed()) return;

    var clickKey = method + '|' + String(element.getAttribute && element.getAttribute('href') || '');
    var now = Date.now();
    if (clickKey === lastClickKey && now - lastClickAt < 1_500) return;
    lastClickKey = clickKey;
    lastClickAt = now;
    document.documentElement.setAttribute('data-saunamo-meta-contact-last-method', method);

    var pageUrl = window.location.href.split('#')[0].slice(0, 2_000);
    deliver({
      event_id: eventId(),
      contact_method: method,
      page_url: pageUrl,
      attribution: attribution()
    });
  }, true);
})();
